import useFocus from "@/lib/hooks/interactions/other/useFocus";
import { AlertColorType, Icon } from "@/lib/main";
import { CSSProperties, PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  isSelected: boolean;
  onSelect: () => void;
  disabled?: boolean;
  alertColor?: AlertColorType;
}>;

export default function Option({
  children,
  isSelected,
  onSelect,
  disabled,
}: Props) {
  const { onFocus, onBlur } = useFocus();

  const styles: CSSProperties = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",

    width: "100%",
    height: "3rem",
    padding: "0 var(--spacing-md)",

    backgroundColor: isSelected
      ? "var(--color-background-frame)"
      : "var(--color-background-canvas)",
    color: `var(--color-text-${disabled ? "disabled" : "primary"})`,
    fontSize: "var(--font-size-xs)",
    cursor: disabled ? "not-allowed" : "pointer",
    borderBottom: `var(--border-width-xs) solid var(--color-border-subtle)`,

    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  };

  return (
    <span
      onClick={disabled ? undefined : onSelect}
      onFocus={onFocus}
      onBlur={onBlur}
      style={styles}
    >
      {children}
      {isSelected && <Icon name="check" color="primary" size="md" />}
    </span>
  );
}
